export enum SpaceMeta {
  MODEL = "space",
  PK = "id",
}
